// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { getEvent } from "./Event";
import { WebPageComponent } from "./WebSite.Page.Component";

export class FormFeedback extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.collapsed = new HtmlClassSwitch(this.element, "collapsed");
    this.closeButton = query.getDescendant(WithClass("close"));
  }

  close() {
    this.collapsed.setStatus(true);
  }

  attachEventHandlers() {
    this.closeButton.onclick = (event) => { this.close(getEvent(event)); };
  }
}

export class FeedbackForm extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachEventHandlers();
  }

  determineElements() {
    const query = new DomQuery(this.element);

    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.expanded.setStatus(false);

    this.label = query.getDescendant(WithClass("Label"));
  }

  toggleForm() {
    this.expanded.toggle();
  }

  attachEventHandlers() {
    this.label.onclick = (event) => { this.toggleForm(getEvent(event)); };
  }
}

interactivityRegistration.register("feedback", function (element) { return new FormFeedback(element); });
interactivityRegistration.register("FeedbackForm", function (element) { return new FeedbackForm(element); });
